import { createRouter, createWebHistory } from 'vue-router';

import { h, resolveComponent } from 'vue'
import DefaultLayout from '../layouts/DefaultLayout'
import AuthLayout from '../layouts/AuthLayout'
import HomeLayout from "../layouts/HomeLayount";

import userService from "../helpers/user.service.js";
import moment from "moment";

import { initWebPush } from "../plugins/webPush";
import { initPush } from "../plugins/push";

import { DEFAULT_LOCALE, buildLocaleMessages } from '../models/localizacao';

const localeMessages = buildLocaleMessages();

// Função helper para obter tradução
function getTranslation(key) {
  const locale = localStorage.getItem('app-locale') || DEFAULT_LOCALE;
  if (!localStorage.getItem('app-locale'))
    localStorage.setItem('app-locale', locale);

  const keys = key.split('.');
  let value = localeMessages[locale];

  for (const k of keys) {
    value = value[k];
    if (!value) break;
  }

  return value || key;
}

function validarRotaRegistro(to, from) {

  if (!["criar", "editar"].includes(to.params?.method.toLowerCase()) && Object.keys(to.params).length < 2) {
    swalToast.fire('Erro', `Método passado inválido, permitidos: [criar, editar]`, 'error');
    return { path: from.path, query: from.query, hash: from.hash }
  }

  if (["editar"].includes(to.params?.method.toLowerCase()) && Object.keys(to.params).length < 2) {
    swalToast.fire('Erro', `O Método atualizar requer o parâmetro id`, 'error');
    return { path: from.path, query: from.query, hash: from.hash }
  }
}

function validarPermissao(to, from) {

  // validação modo aluno
  let modoAluno = (window.localStorage.getItem("idModoAluno") != null)
  if (modoAluno && to.path.split('/')[1] !== 'aluno') {
    swalToast.fire('Erro', `Acesso não permitido enquanto no modo aluno`, 'warning');
    next({
      path: '/aluno/sala-de-aula/disciplina/atuais',
      replace: true
    })
  }

}

function needAuthenticate(path) {

  if (window.rotasSemAuth.includes(`/${path.split('/')[1]}`))
    return false

  return true
}


function validarIdInteiro(to, from, next) {
  const id = String(to.params?.id ?? '')
  if (!/^\d+$/.test(id)) {
    swalAlert.fire('Erro', `URL Inválida`, 'error')
    next(false)
    return
  }
  next()
}

const routes = [
  {
    path: '/',
    name: 'index',
    component: HomeLayout,
    redirect: '/login',
    children: [
      {
        path: '/privacidade',
        name: 'Privacidade',
        component: () => import('../views/pages/pagesHome/privacidade'),
      },
      {
        path: '/termouso',
        name: 'Termos de Uso',
        component: () => import('../views/pages/pagesHome/termouso'),
      },
      {
        path: '/',
        name: '',
        component: () => import('../views/pages/home/dashboardindex'),
        redirect: '/login',
      },
      {
        path: '/404',
        name: '',
        component: () => import('../views/pages/pages/error/error-404'),
      },
      {
        path: '/500',
        name: '',
        component: () => import('../views/pages/pages/error/error-500'),
      },
      {
        path: '/em-breve',
        name: 'Em Breve',
        component: () => import('../views/pages/pages/error/come-soon'),
      },
      {
        path: '/em-construcao',
        name: 'Em Construção',
        component: () => import('../views/pages/pages/error/under-construction'),
      },
      {
        path: '/teste-upload',
        name: 'teste upload',
        component: () => import('../views/pages/pagesHome/testeUpload'),
      },
    ]
  },
  {
    path: '/auth',
    name: 'auth',
    component: AuthLayout,
    redirect: '/',
    children: [
      {
        path: '/login',
        name: 'Login',
        component: () => import('../views/pages/auth/login'),
      },
      {
        path: '/login/externo',
        name: 'Login Externo',
        component: () => import('../views/pages/auth/login'),
      },
      {
        path: '/sso/callback',
        name: 'SSO Callback',
        component: () => import('../views/pages/auth/sso-callback'),
      },
      {
        path: '/recuperar-senha',
        name: 'Recuperar Senha',
        component: () => import('../views/pages/auth/recuperar-senha'),
      },
      {
        path: '/alterar-senha/:id/:token?',
        name: 'Alterar Senha',
        component: () => import('../views/pages/auth/alterar-senha'),
      },
    ]
  },
  {
    path: '/inicio',
    name: getTranslation('routes.home'),
    component: DefaultLayout,
    redirect: '/',
    children: [
      {
        path: '/inicio',
        name: getTranslation('routes.home'),
        component: () => import('../views/pages/pagesHome'),
      },
      // {
      //   path: '/teste-pdf',
      //   name: 'teste pdf',
      //   component: () => import('../views/pages/pagesHome/testePDF'),
      // },
      // {
      //   path: '/teste-upload',
      //   name: 'teste upload',
      //   component: () => import('../views/pages/pagesHome/testeUpload'),
      // },
      {
        path: '/perfil',
        name: 'Meu Perfil',
        component: () => import('../views/pages/Usuario/Perfil'),
      },
      {
        path: '/perfil/alterar-senha',
        name: 'Alterar Minha Senha',
        component: () => import('../views/pages/Usuario/AlterarSenha')
      },
      /*
       * -------------------------------------------------------
       * menus
       */
      {
        path: '/aluno/documentos/:tipo?',
        name: getTranslation('routes.documents'),
        component: () => import('../views/pages/Documentos/Documentos.vue'),
        beforeEnter: [validarPermissao],
      },
      {
        path: '/aluno',
        name: getTranslation('routes.classroom'),
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/aluno/sala-de-aula',
        children: [
          {
            path: '/aluno/notas',
            name: getTranslation('routes.myGrades'),
            component: () => import('../views/pages/Notas/AlunoNotas'),
            beforeEnter: [validarPermissao],
          },
          {
            path: '/aluno/boletim',
            name: getTranslation('routes.boletim'),
            component: () => import('../views/pages/Notas/AlunoBoletim'),
            beforeEnter: [validarPermissao],
          },
          {
            path: '/aluno/atividades-complementares',
            name: getTranslation('routes.atividadesComplementares'),
            component: () => import('../views/pages/AtividadesComplementares/AlunoAtividadesComplementares'),
            beforeEnter: [validarPermissao],
          },
          {
            path: '/aluno/cursos',
            name: getTranslation('routes.alunoCursos'),
            component: () => import('../views/pages/Cursos/AlunoCursos.vue'),
            beforeEnter: [validarPermissao],
          },
          {
            path: '/aluno/solicitacoes',
            name: getTranslation('routes.solicitacoes'),
            component: () => import('../views/pages/Solicitacao/SolicitacaoLista.vue'),
            beforeEnter: [validarPermissao],
          },
          {
            path: '/aluno/adapt',
            name: getTranslation('routes.adapt'),
            component: () => import('../views/pages/Adapt/AlunoAdapt.vue'),
            beforeEnter: [validarPermissao],
          },
          {
            path: '/aluno/sub',
            name: getTranslation('routes.sub'),
            component: () => import('../views/pages/Sub/AlunoSub.vue'),
            beforeEnter: [validarPermissao],
          },
          {
            path: '/aluno/financeiro',
            name: getTranslation('routes.financeiro'),
            component: () => import('../views/pages/Financeiro/AlunoFinanceiro.vue'),
            beforeEnter: [validarPermissao],
          },
          {
            path: '/aluno/renegociacao',
            name: getTranslation('routes.renegociacao'),
            component: () => import('../views/pages/Renegociacao/AlunoRenegociacao.vue'),
            beforeEnter: [validarPermissao],
          },
          {
            path: '/aluno/atendimento/solicitacao',
            redirect: '/aluno/solicitacoes',
          },
          {
            path: '/aluno/atendimento/historico',
            redirect: '/aluno/solicitacoes',
          },
          {
            path: '/aluno/sala-de-aula/disciplina',
            name: getTranslation('routes.disciplines'),
            component: {
              render() {
                return h(resolveComponent('router-view'))
              },
            },
            redirect: '/aluno/sala-de-aula/disciplina/atuais',
            children: [
              {
                path: '/aluno/sala-de-aula/disciplina/:tipo/:login?',
                name: getTranslation('routes.disciplines'),
                component: () => import('../views/pages/SalaDeAula/ListaDisciplinas'),
                beforeEnter: [validarPermissao],
              },
              {
                path: '/aluno/sala-de-aula/disciplina/modulo/:id/:nome?',
                name: getTranslation('routes.modules'),
                component: () => import('../views/pages/SalaDeAula/VisualizarDisciplina'),
                beforeEnter: [validarPermissao, validarIdInteiro],
              },
              {
                path: '/aluno/sala-de-aula/disciplina/modulo/aula/:id/:nome?',
                name: getTranslation('routes.watchClass'),
                component: () => import('../views/pages/SalaDeAula/Aula'),
                beforeEnter: [validarPermissao, validarIdInteiro],
              },
              {
                path: '/aluno/sala-de-aula/disciplina/modulo/atividade/:id/:nome?',
                name: getTranslation('routes.activity'),
                component: () => import('../views/pages/SalaDeAula/Atividade'),
                beforeEnter: [validarPermissao, validarIdInteiro],
              },
            ]
          },
          {
            path: '/aluno/mensagens/:tipo?',
            name: getTranslation('routes.inbox'),
            component: () => import('../views/pages/Mensagens/CaixaDeEntrada'),
            beforeEnter: [validarPermissao]
          },
        ],
      },
      {
        path: '/administrativo',
        name: 'Administrativo',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/inicio',
        children: [
          {
            path: '/administrativo/franqueado',
            name: 'Franquia',
            component: {
              render() {
                return h(resolveComponent('router-view'))
              },
            },
            redirect: '/administrativo/franqueado',
            children: [
              {
                path: '/administrativo/franqueado',
                name: 'Franqueados',
                component: () => import('../views/pages/Franqueado/FranqueadoLista'),
                beforeEnter: [validarPermissao]
              },
              {
                path: '/administrativo/franqueado/:method/:id?/:tab?',
                name: 'Cadastro de Franqueado',
                component: () => import('../views/pages/Franqueado/FranqueadoRegistro'),
                beforeEnter: [validarRotaRegistro, validarPermissao]
              },
            ]
          },
          {
            path: '/administrativo/usuario',
            name: 'Usuário',
            component: {
              render() {
                return h(resolveComponent('router-view'))
              },
            },
            redirect: '/administrativo/usuario',
            children: [
              {
                path: '/administrativo/usuario',
                name: 'Usuários Administrativos',
                component: () => import('../views/pages/Usuario/UsuarioLista'),
                beforeEnter: [validarPermissao],
              },
              {
                path: '/administrativo/aluno',
                name: 'Alunos',
                component: () => import('../views/pages/Usuario/UsuarioLista'),
                beforeEnter: [validarPermissao],
              },
              {
                path: '/administrativo/usuario/:method/:id?/:tab?',
                name: 'Cadastro de Usuário',
                component: () => import('../views/pages/Usuario/UsuarioRegistro'),
                beforeEnter: [validarRotaRegistro, validarPermissao]
              },
            ]
          },
          {
            path: '/administrativo/perfil',
            name: 'Perfil',
            component: {
              render() {
                return h(resolveComponent('router-view'))
              },
            },
            redirect: '/administrativo/perfil',
            children: [
              {
                path: '/administrativo/perfil',
                name: 'Perfil',
                component: () => import('../views/pages/Perfil/PerfilLista'),
                beforeEnter: [validarPermissao]
              },
              {
                path: '/administrativo/perfil/:method/:id?',
                name: 'Cadastro de Perfil ',
                component: () => import('../views/pages/Perfil/PerfilRegistro'),
                beforeEnter: [validarRotaRegistro, validarPermissao]
              },
              {
                path: '/administrativo/perfil/permissoes/:method/:id?',
                name: 'Perfil de Permissões',
                component: () => import('../views/pages/Perfil/PerfilPermissoes/PerfilPermissoes'),
                beforeEnter: [validarRotaRegistro, validarPermissao]
              },
            ]
          },
          {
            path: '/administrativo/contatos-aluno',
            name: 'Contatos do Aluno',
            component: () => import('../views/pages/Contato/ContatoLista'),
            beforeEnter: [validarPermissao],
          },
          {
            path: '/administrativo/instrutor',
            name: 'Professores da Disciplina',
            component: {
              render() {
                return h(resolveComponent('router-view'))
              },
            },
            redirect: '/administrativo/instrutor',
            children: [
              {
                path: '/administrativo/instrutor/:id?',
                name: 'Professores da Disciplina',
                component: () => import('../views/pages/InstrutorDisciplina/InstrutorDisciplina'),
                beforeEnter: [validarPermissao]
              },
            ]
          },
          {
            path: '/administrativo/atividades-em-andamento',
            name: 'Atividades Em Andamento',
            component: () => import('../views/pages/AtividadesEmAndamento/AtividadesEmAndamentoLista'),
            beforeEnter: [validarPermissao]
          },
          {
            path: '/administrativo/entregas-atividade',
            name: 'Entregas de Atividades',
            component: () => import('../views/pages/EntregasAtividade/EntregasAtividades'),
            beforeEnter: [validarPermissao]
          },
          {
            path: '/administrativo/relatorios',
            name: 'Relatórios',
            component: {
              render() {
                return h(resolveComponent('router-view'))
              },
            },
            redirect: '/administrativo/relatorios',
            children: [
              {
                path: '/administrativo/relatorios/atividades',
                name: 'Atividades',
                component: () => import('../views/pages/Relatorios/RelatorioAtividades'),
                beforeEnter: [validarPermissao]
              },
              {
                path: '/administrativo/relatorios/aulas',
                name: 'Aulas',
                component: () => import('../views/pages/Relatorios/RelatorioAtividades'),
                beforeEnter: [validarPermissao]
              },
              {
                path: '/administrativo/relatorios/correcaoatividades',
                name: 'Correção de Atividades',
                component: () => import('../views/pages/Relatorios/CorrecaoAtividades'),
                beforeEnter: [validarPermissao]
              },
              {
                path: '/administrativo/relatorios/alunosexame',
                name: 'Alunos em Exame',
                component: () => import('../views/pages/Relatorios/AlunosExame'),
                beforeEnter: [validarPermissao]
              },
              {
                path: '/administrativo/relatorios/resumodisciplina',
                name: 'Resumo da Disciplina',
                component: () => import('../views/pages/Relatorios/ResumoDisciplina.vue'),
                beforeEnter: [validarPermissao]
              },
              {
                path: '/administrativo/relatorios/desempenho-aluno',
                name: 'Desempenho do Aluno',
                component: () => import('../views/pages/Relatorios/DesempenhoAluno.vue'),
                beforeEnter: [validarPermissao]
              },
              {
                path: '/administrativo/relatorios/detalhado-aluno',
                name: 'Aluno Detalhado',
                component: () => import('../views/pages/Relatorios/DetalhadoAluno/DetalhadoAluno.vue'),
                beforeEnter: [validarPermissao]
              },
              {
                path: '/administrativo/relatorios/confronto-situacao-aluno',
                name: 'Confronto Situação Aluno',
                component: () => import('../views/pages/Relatorios/Sincronia/ConfrontoSituacaoAluno.vue'),
                beforeEnter: [validarPermissao]
              },
            ]
          },
        ]
      },
      {
        path: '/academico',
        name: 'Acadêmico',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/inicio',
        children: [
          {
            path: '/academico/bancoperguntas',
            name: 'Banco de Perguntas',
            component: {
              render() {
                return h(resolveComponent('router-view'))
              },
            },
            redirect: '/academico/bancoperguntas',
            children: [
              {
                path: '/academico/bancoperguntas',
                name: '',
                component: () => import('../views/pages/BancoPerguntas/BancoPerguntasLista'),
                beforeEnter: [validarPermissao]
              },
              {
                path: '/academico/bancoperguntas/:method/:id?/:tab?',
                name: 'Cadastro de Banco de Perguntas',
                component: () => import('../views/pages/BancoPerguntas/BancoPerguntasRegistro'),
                beforeEnter: [validarRotaRegistro, validarPermissao]
              },
            ]
          },
          {
            path: '/academico/disciplina',
            name: 'Disciplina',
            component: {
              render() {
                return h(resolveComponent('router-view'))
              },
            },
            redirect: '/academico/disciplina',
            children: [
              {
                path: '/academico/disciplina',
                name: 'Disciplina',
                component: () => import('../views/pages/Disciplina/DisciplinaLista'),
                beforeEnter: [validarPermissao]
              },
              {
                path: '/academico/disciplina/processo-copia',
                name: 'Processo de Cópia de Disciplinas',
                component: () => import('../views/pages/Disciplina/ProcessoCopia/ProcessoCopiaLista'),
                beforeEnter: [validarPermissao]
              },
              {
                path: '/academico/disciplina/:method/:id?/:tab?',
                name: 'Cadastro de Disciplina',
                component: () => import('../views/pages/Disciplina/DisciplinaRegistro'),
                beforeEnter: [validarRotaRegistro, validarPermissao]
              },
              {
                path: '/academico/disciplina/modulo/:method/:id?/:tab?',
                name: 'Cadastro de Módulo',
                component: () => import('../views/pages/Modulo/ModuloRegistro'),
                beforeEnter: [validarRotaRegistro, validarPermissao]
              },
              {
                path: '/academico/disciplina/modulo/aula/:method/:id?',
                name: 'Cadastro de Aula',
                component: () => import('../views/pages/Aula/AulaRegistro'),
                beforeEnter: [validarRotaRegistro, validarPermissao]
              },
              {
                path: '/academico/disciplina/modulo/atividade/:method/:id?/:tab?',
                name: 'Cadastro de Atividade',
                component: () => import('../views/pages/Atividade/AtividadeRegistro'),
                beforeEnter: [validarRotaRegistro, validarPermissao]
              },
            ]
          },
          {
            path: '/academico/curso',
            name: 'Cursos',
            component: {
              render() {
                return h(resolveComponent('router-view'))
              },
            },
            redirect: '/academico/curso',
            children: [
              {
                path: '/academico/curso',
                name: 'Cursos',
                component: () => import('../views/pages/Curso/CursoLista'),
                beforeEnter: [validarPermissao]
              },
              {
                path: '/academico/curso/:method/:id?/:tab?',
                name: 'Cadastro de Curso',
                component: () => import('../views/pages/Curso/CursoRegistro'),
                beforeEnter: [validarRotaRegistro, validarPermissao]
              },
            ],
          },
          {
            path: '/academico/periodo-letivoo',
            name: 'Período Letivo',
            component: {
              render() {
                return h(resolveComponent('router-view'))
              },
            },
            redirect: '/academico/periodo-letivo',
            children: [
              {
                path: '/academico/periodo-letivo',
                name: 'Período Letivo',
                component: () => import('../views/pages/PeriodoLetivo/PeriodoLetivoLista'),
                beforeEnter: [validarPermissao],
              },
              {
                path: '/academico/periodo-letivo/:method/:id?/:tab?',
                name: 'Cadastro Período Letivo',
                component: () => import('../views/pages/PeriodoLetivo/PeriodoLetivoRegistro'),
                beforeEnter: [validarRotaRegistro, validarPermissao]
              },
            ],
          },
          {
            path: '/academico/turma',
            name: 'Turmas',
            component: {
              render() {
                return h(resolveComponent('router-view'))
              },
            },
            redirect: '/academico/turma',
            children: [
              {
                path: '/academico/turma',
                name: 'Turmas',
                component: () => import('../views/pages/Turma/TurmaLista'),
                beforeEnter: [validarPermissao]
              },
              {
                path: '/academico/turma/:method/:id?/:tab?',
                name: 'Cadastro de Turma',
                component: () => import('../views/pages/Turma/TurmaRegistro'),
                beforeEnter: [validarRotaRegistro, validarPermissao]
              },
            ]
          },
          {
            path: '/academico/notas',
            name: 'Notas',
            component: {
              render() {
                return h(resolveComponent('router-view'))
              },
            },
            redirect: '/academico/notas',
            children: [
              {
                path: '/academico/notas',
                name: 'Notas',
                component: () => import('../views/pages/Notas/Notas'),
                beforeEnter: [validarPermissao]
              },
            ]
          },
          {
            path: '/academico/mensagens/:tipo?',
            name: 'Caixa de Entrada',
            component: () => import('../views/pages/Mensagens/CaixaDeEntrada'),
            beforeEnter: [validarPermissao]
          },
        ] // academico
      },
      {
        path: '/configuracao',
        name: 'Configuração',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/inicio',
        children: [
          {
            path: '/configuracao/log',
            name: 'Log do Sistema',
            component: {
              render() {
                return h(resolveComponent('router-view'))
              },
            },
            redirect: '/configuracao/log',
            children: [
              {
                path: '/configuracao/log',
                name: 'Log do Sistema',
                component: () => import('../views/pages/Log/Log'),
                beforeEnter: [validarPermissao]
              }
            ]
          },
          {
            path: '/configuracao/logmensagem',
            name: 'Log de Mensagens',
            component: () => import('../views/pages/Log/MensagemLog'),
            beforeEnter: [validarPermissao]
          }
        ] // configuração
      }
    ]
  },
];

export const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  linkActiveClass: 'active',
  routes,
  scrollBehavior() {
    return { top: 0 } //// always scroll to top
  },
})

router.beforeEach((to, from, next) => {


  // se um modal esta aberto, fecha o modal para não atrapalhar a navegação
  const backdrop = document.querySelector('.modal-backdrop.fade');
  if (backdrop) {
    backdrop.remove();

    const modal = document.querySelector('.modal.show');
    modal.classList.remove('show');
    modal.style.display = 'none';

    const body = document.querySelector('body.modal-open');
    body.classList.remove('modal-open')
    body.removeAttribute('style');

  }


  const path = to.path.toLowerCase()
  let user = userService.getLocalUser(false);
  let expirado = true

  if (user) {
    const expires_time = moment.unix(user.created_at).add(user.expires_in / 60, 'minute').format("YYYY-MM-DD HH:mm:ss");
    expirado = (moment(new Date(expires_time)).diff(new Date(), 'minutes') < 1)
  }

  if (needAuthenticate(path)) {
    if (expirado) {
      userService.destroyUser()
      userService.setLoginMessage('Sessão não encontrada, entre novamente com a sua conta')
      next({
        path: '/login',
        replace: true
      })
      return
    }
  }

  // validacão aluno, só pode acessar rotas com /aluno
  if (user?.Usuario?.Usuario?.TipoUsuario == 'aluno') {
    // verifica se a rota tem /aluno

    if (!['aluno', 'perfil', 'login'].includes(path.split('/')[1])) {
      swalToast.fire('Erro', `Acesso não permitido para o tipo de usuário, você foi redirecionado para home`, 'warning');
      next({
        path: '/aluno/sala-de-aula/disciplina/atuais',
        replace: true
      })
      return
    }
  }

  if (path == '/login' && !expirado) {

    if (user.Usuario.Usuario.TipoUsuario == 'administrativo') {
      next({
        path: '/inicio',
        replace: true
      })
      return
    }

    next({
      path: '/aluno/sala-de-aula/disciplina',
      replace: true
    })
    return

  }

  next();

})


router.afterEach((to, from, next) => {

  const path = to.path.toLowerCase()
  let user = userService.getLocalUser(false);

  // inicializa push notifications
  if (!path.includes('/perfil') && !path.includes('/login') && !path.includes('/aluno/sala-de-aula/disciplina/modulo/atividade')) {
    // Inicializa push notifications baseado na plataforma
    if (Capacitor.getPlatform() === 'web') {
      initWebPush();
    } else {
      initPush();
    }
  }

})

